/** English strings. The key set is the source of truth; sr.ts must have exactly the same keys. */
export const en = {
  "admin.invites.col.link": "Link",
  "admin.tabs.invites": "Invites",
  "admin.pendingInvite": "Invite for {email}",
  "admin.invites.title": "Invites",
  "admin.requests.title": "Invite requests",
  "admin.requests.empty": "No invite requests.",
  "admin.requests.col.team": "Team",
  "admin.requests.col.message": "Message",
  "admin.requests.col.received": "Received",
  "admin.requests.showMessage": "Show full message",
  "admin.requests.hideMessage": "Hide message",
  "admin.requests.noMessage": "No message",
  "admin.requests.createInvite": "Create invite",
  "admin.requests.dismiss": "Dismiss",
  "admin.requests.dismissTitle": "Dismiss request",
  "admin.requests.dismissMessage":
    "Dismiss the request from {email}? It leaves the queue and no invite is sent.",
  "admin.requests.countLabel": "{count} new invite requests",
  "admin.invites.empty": "No invites yet.",
  "admin.invites.col.expires": "Expires",
  "admin.invites.status.pending": "Pending",
  "admin.invites.status.opened": "Opened",
  "admin.invites.status.used": "Used",
  "admin.invites.status.expired": "Expired",
  "admin.invites.status.revoked": "Revoked",
  "admin.invites.linkUnavailable": "Link unavailable. Generate a new one.",
  "admin.invites.resend": "Resend",
  "admin.invites.newLink": "New link",
  "admin.invites.revoke": "Revoke",
  "admin.invites.newLinkTitle": "New link",
  "admin.invites.newLinkMessage":
    "Create a new link for {email}? The old link stops working at once.",
  "admin.invites.revokeTitle": "Revoke invite",
  "admin.invites.revokeMessage": "Revoke the invite for {email}? Its link stops working at once.",
  "roster.invite": "Invite player",
  "roster.inviteTitle": "Invite a player",
  "roster.inviteSubmit": "Create invite link",
  "roster.linkCreate": "Create link",
  "roster.linkUnavailable": "Link unavailable. Generate a new one.",
  "roster.opened": "Opened {when}",
  "roster.notOpened": "Not opened",
  "roster.songChosen": "Song chosen",
  "roster.qr": "QR",
  "roster.shareLink": "Share link",
  "roster.moreActions": "More actions for {name}",
  "roster.lockSong": "Lock song",
  "roster.unlockSong": "Unlock song",
  "roster.regenerate": "Regenerate link",
  "roster.statusLocked": "Locked",
  "roster.statusOpened": "Link opened",
  "roster.statusNoLink": "No link",
  "roster.deletedOn": "Deleted {date}",
  "roster.tryAgain": "Try again",
  "link.intro": "Share this link with {name}.",
  "link.regenerated": "The previous link no longer works.",
  "invitePage.for": "Invitation for {email} to {workspace}",
  "invitePage.noWorkspace": "a workspace",
  "invitePage.invalidTitle": "This invitation can't be used",
  "invitePage.invalidText": "Ask the person who invited you for a new link.",

  "app.name": "Goalhorns Online",
  "app.loading": "Loading…",
  "app.retry": "Try again",

  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.delete": "Delete",
  "common.restore": "Restore",
  "common.edit": "Edit",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.share": "Share",
  "common.add": "Add",
  "common.remove": "Remove",
  "common.rename": "Rename",
  "common.duplicate": "Duplicate",
  "common.open": "Open",
  "common.create": "Create",
  "common.confirm": "Confirm",
  "common.none": "None",
  "common.active": "Active",
  "common.inactive": "Inactive",
  "common.locked": "Locked",
  "common.unlocked": "Unlocked",
  "common.deleted": "Deleted",
  "common.filterActive": "Active",
  "common.filterDeleted": "Deleted",
  "common.role.owner": "Owner",
  "common.role.member": "Member",

  "auth.login.title": "Sign in",
  "auth.login.subtitle": "Manage your rosters, configurations and exports.",
  "auth.login.google": "Sign in with Google",
  "auth.login.inviteNote": "You were invited. Sign in with the invited email address.",
  "auth.dev.title": "Development sign-in",
  "auth.dev.email": "Email",
  "auth.dev.submit": "Sign in as this email",
  "auth.invite.title": "Accept your invitation",
  "auth.invite.text": "Sign in with the email address the invitation was sent to.",
  "auth.error.oauth_state_invalid": "Sign-in expired or was interrupted. Please try again.",
  "auth.error.email_unverified": "Your Google email address is not verified.",
  "auth.error.not_invited": "This account is not invited to Goalhorns.",
  "auth.error.invite_invalid": "This invite is expired, already used or revoked.",
  "auth.error.invite_email_mismatch": "This invite was issued to a different email address.",
  "auth.error.oauth_not_configured": "Google sign-in is not configured.",
  "auth.error.oauth_exchange_failed": "Google sign-in could not be completed. Please try again.",
  "auth.error.rate_limited": "Too many sign-in attempts. Wait a minute and try again.",
  "auth.error.unknown": "Sign-in failed, please try again.",

  "nav.roster": "Roster",
  "nav.configurations": "Configurations",
  "nav.members": "Members",
  "nav.usage": "Usage",
  "nav.desktops": "Desktops",
  "nav.label": "Workspace sections",

  "workspace.switch": "Workspace",
  "workspace.recent": "Recent workspaces",
  "workspace.none": "No workspace yet",
  "workspace.noneText": "Open a workspace by its ID, or accept an invitation.",
  "workspace.idLabel": "Workspace ID",
  "workspace.open": "Open workspace",
  "workspace.acting": "Acting as workspace {name}. Every action is audited.",
  "workspace.stopActing": "Stop acting",
  "workspace.missing": "This workspace does not exist, or your account cannot open it.",
  "workspace.backToList": "Back to your workspaces",
  "workspace.yours": "Your workspaces",
  "workspace.openRow": "Open",
  "common.role.admin": "Admin",

  "user.menu": "Account",
  "user.signOut": "Sign out",
  "lang.label": "Language",
  "lang.en": "EN",
  "lang.rs": "RS",
  "lang.ru": "RU",

  "roster.title": "Roster",
  "roster.add": "Add person",
  "roster.empty": "No one on the roster yet.",
  "roster.emptyDeleted": "No deleted people.",
  "roster.changed": "Changed",
  "roster.photoLocked": "Photo locked",
  "roster.noPhoto": "No photo",
  "roster.noSong": "No song yet",
  "roster.number": "No. {number}",
  "roster.noNumber": "No number",
  "roster.region": "Region {region}",
  "roster.newLink": "New link",
  "roster.uploadPhoto": "Upload photo",
  "roster.replacePhoto": "Replace photo",
  "roster.lockPhoto": "Lock photo",
  "roster.unlockPhoto": "Unlock photo",
  "roster.songLocked": "Song locked",
  "roster.songUnlocked": "Song unlocked",
  "roster.confirmDelete": "Delete {name}? You can restore them for 30 days.",
  "roster.confirmRegenerate": "Create a new link for {name}? The old link stops working at once.",
  "roster.photoTooLarge": "The photo is larger than 5 MB.",
  "roster.photoType": "Use a PNG or JPEG photo.",
  "roster.uploading": "Uploading photo",

  "person.addTitle": "Add person",
  "person.editTitle": "Edit person",
  "person.name": "Name",
  "person.number": "Number",
  "person.numberHint": "Optional, 0 to 999.",
  "person.invalidName": "Enter a name up to 80 characters.",
  "person.invalidNumber": "The number must be a whole number from 0 to 999.",

  "link.title": "Player link",
  "link.share": "Share",
  "link.qrLabel": "QR code for this player's link",
  "link.shareUnsupported": "Sharing is not available in this browser. Use Copy.",

  "configs.title": "Configurations",
  "configs.create": "New configuration",
  "configs.nameLabel": "Name",
  "configs.namePlaceholder": "Configuration name",
  "configs.empty": "No configurations yet.",
  "configs.emptyDeleted": "No deleted configurations.",
  "configs.changedSince": "{count} changed since your last download",
  "configs.neverDownloaded": "Never downloaded",
  "configs.lockSwitch": "Unlocked",
  "configs.unlockSwitch": "Lock or unlock {name}",
  "configs.rename": "Rename configuration",
  "configs.confirmDelete": "Delete {name}? You can restore it for 30 days.",
  "configs.createSubmit": "Create",
  "configs.lockForGame": "Lock for game",
  "configs.unlock": "Unlock",
  "configs.open": "Open",
  "configs.openLineup": "Open lineup",
  "configs.players": "players",
  "configs.downloadedAt": "Downloaded {when}",
  "configs.more": "More actions for {name}",

  "editor.back": "All configurations",
  "editor.addPerson": "Add to configuration",
  "editor.pickPerson": "Choose a person",
  "editor.noAvailable": "Everyone on the roster is in this lineup.",
  "editor.empty": "This configuration has no slots yet.",
  "editor.save": "Save slots",
  "editor.discard": "Discard changes",
  "editor.saved": "Slots saved.",
  "editor.dirty": "Unsaved changes",
  "editor.locked": "This configuration is locked. Unlock it to edit slots.",
  "editor.changedList": "Changed since your last download",
  "editor.changedSummary": "{count} players changed since your last download",
  "editor.changedNone": "Nothing changed since your last download.",
  "editor.dragHandle": "Drag to reorder",
  "editor.slot": "Slot {position}",
  "editor.activeLabel": "Active",
  "editor.hotkey": "Hotkey",
  "editor.hotkeyNone": "No hotkey",
  "editor.setHotkey": "Set hotkey",
  "editor.changeHotkey": "Change",
  "editor.hotkeyClear": "Clear",
  "editor.clearHotkey": "Clear hotkey for {name}",
  "editor.hotkeyPress": "Press keys…",
  "editor.hotkeyHint":
    "Hold the keys, then release them all to save. Esc alone cancels. Modifier keys alone are ignored.",
  "editor.hotkeyIgnored": "A hotkey needs a non-modifier key.",
  "editor.hotkeyLocal": "Hotkey conflict in this configuration",
  "editor.hotkeyReservedLocal": "This hotkey is reserved by the desktop app",
  "editor.hotkeyDuplicateLocal": "Another slot already uses this hotkey",
  "editor.slotsErrorTitle": "The server did not save the slots",
  "editor.removeConfirm": "Remove {name} from this configuration?",
  "editor.lockedBand": "LOCKED — players can't change their songs",
  "editor.bench": "Bench",
  "editor.addPlayers": "Add players",
  "editor.searchPlayers": "Search players",
  "editor.addPlayer": "Add {name}",
  "editor.noMatches": "No players match this search.",
  "editor.removeFromLineup": "Remove {name} from the lineup. They stay on the roster.",

  "export.button": "Download .goalhorns",
  "export.preparing": "Preparing bundle…",
  "export.progress": "Adding media {done} of {total}",
  "export.marking": "Recording download…",
  "export.done": "Downloaded {name}.",
  "export.cancelled": "Download cancelled.",
  "export.noMedia": "No media to add.",
  "export.building": "Building .goalhorns… {percent}%",

  "members.title": "Members",
  "members.ownerOnly": "Only the workspace owner can manage members.",
  "members.invite": "Invite a co-operator",
  "members.email": "Email",
  "members.role": "Role",
  "members.inviteButton": "Send invite",
  "members.inviteOnce":
    "Send this link to the invitee. It is shown only once and cannot be displayed again.",
  "members.pending": "Pending invitations",
  "members.noPending": "No pending invitations.",
  "members.makeOwner": "Make owner",
  "members.makeMember": "Make member",
  "members.moreActions": "More actions for {name}",
  "members.inviteStatusPending": "Pending",
  "members.inviteStatusExpired": "Expired",
  "members.resend": "Resend",
  "members.confirmRevokeTitle": "Revoke invitation",
  "members.confirmRevoke": "Revoke the invitation for {email}? Its link will stop working.",
  "members.expires": "Expires {date}",
  "members.revoke": "Revoke",
  "members.roster": "People with access",
  "members.you": "You",
  "members.confirmRemove": "Remove {name} from this workspace?",
  "members.ownerProtected": "Owner",

  "usage.title": "Usage",
  "usage.bytes": "Storage",
  "usage.persons": "People",
  "usage.configurations": "Configurations",
  "usage.of": "{used} of {quota}",
  "usage.noQuota": "{used} in use (no quota)",
  "usage.unitPeople": "players",
  "usage.nearLimit": "Almost full. Free up room before adding more.",

  "keys.title": "API keys",
  "keys.note": "Sync API coming to the desktop app later. Keys are for future sync only.",
  "keys.label": "Label",
  "keys.create": "Create key",
  "keys.createdOnce": "Copy this key now. It is shown only once and cannot be displayed again.",
  "keys.empty": "No keys for this configuration.",
  "keys.wontSeeAgain": "You won't see this key again. Copy it now and keep it somewhere safe.",
  "keys.submit": "Create",
  "keys.dialogTitle": "New API key",
  "keys.active": "Active",
  "keys.revokedGroup": "Revoked ({count})",
  "keys.moreActions": "More actions for {name}",
  "keys.revokeTitle": "Revoke key",
  "keys.confirmRevoke":
    "Revoke {name}? Anything that uses this key will stop working. This cannot be undone.",
  "keys.done": "Done",
  "keys.revoke": "Revoke",
  "keys.revoked": "Revoked",
  "keys.lastUsed": "Last used {date}",
  "keys.never": "Never used",
  "keys.created": "Created {date}",

  "devices.title": "Desktops",
  "devices.intro": "Link the Goalhorns desktop app to this workspace.",
  "devices.linkButton": "Link a desktop",
  "devices.codeTitle": "Link code",
  "devices.codeSteps": "In the desktop app open Configurations → Online and enter this code.",
  "devices.codeReady": "Code ready. Enter it in the desktop app.",
  "devices.codeExpired": "This code has expired.",
  "devices.countdown": "Code expires in {time}",
  "devices.newCode": "New code",
  "devices.done": "Done",
  "devices.empty": "No desktops linked yet.",
  "devices.linkedBy": "Linked by {email}",
  "devices.linkedOn": "Linked {date}",
  "devices.lastSeen": "Last seen {time}",
  "devices.neverSeen": "Never",
  "devices.moreActions": "More actions for {name}",
  "devices.online": "Online",
  "devices.offline": "Offline",
  "devices.codeLastMinute": "Less than a minute left. Enter the code now.",
  "devices.unlink": "Unlink",
  "devices.confirmUnlinkTitle": "Unlink desktop",
  "devices.confirmUnlink":
    "Unlink {name}? The desktop app will be disconnected and its key will stop working.",

  "tabs.slots": "Slots",
  "tabs.keys": "API keys",

  "page.notFound": "Page not found",
  "page.notFoundText": "The page you are looking for does not exist.",
  "page.home": "Go to start",

  "player.lockedBanner": "Your sound guy locked changes for now",
  "player.invalidTitle": "This link is no longer valid",
  "player.invalidText": "Ask your sound guy for a new one.",
  "player.photo": "Your photo",
  "player.photoAlt": "Your photo",
  "player.photoAdd": "Add a photo",
  "player.photoReplace": "Replace your photo",
  "player.photoUploadLabel": "Upload photo",
  "player.photoReplaceLabel": "Replace photo",
  "player.photoFile": "Photo file",
  "player.photoLockedNote": "Photo set by your sound guy",
  "player.photoSaved": "Photo saved.",
  "player.uploadingPhoto": "Uploading photo {percent}%",
  "player.consent": "I may share this photo; players under 16 need a parent's consent",
  "player.song": "Your song",
  "player.songFile": "Song file",
  "player.songUpload": "Upload song",
  "player.songReplace": "Replace song",
  "player.songHint": "MP3, M4A or AAC, up to 20 MB.",
  "player.consentHint": "Tick the consent box to upload a photo.",
  "player.songLockedNote": "Song set by your sound guy",
  "player.songNone": "No song yet. Upload one, then pick your part (up to 30 seconds).",
  "player.songSaved": "Song uploaded.",
  "player.songTooShort": "This song is shorter than 3 seconds.",
  "player.preparing": "Preparing file…",
  "player.uploading": "Uploading song {percent}%",
  "player.waveformLoading": "Loading waveform…",
  "player.waveformError": "The waveform could not be loaded.",
  "player.play": "Play section",
  "player.stop": "Stop",
  "player.regionLength": "{seconds} seconds",
  "player.regionSaved": "Your region is saved. Your sound guy will get it on the next update.",
  "player.lockedTitle": "Locked by your sound guy",
  "player.lockedExplain": "You can still listen to your section.",
  "player.invalidFull": "This link no longer works. Ask your sound guy for a new one.",
  "player.sectionLabel": "Your section",

  "error.unknown": "Something went wrong. Please try again.",
  "error.network_error": "No connection. Check your network and try again.",
  "error.bad_response": "The server sent an unexpected response.",
  "error.unknown_error": "Something went wrong. Please try again.",
  "error.internal_error": "Internal server error. Please try again later.",
  "error.http_error": "The request could not be completed.",
  "error.validation_error": "Some of the entered data is not valid.",
  "error.not_found": "This item was not found.",
  "error.unauthorized": "Please sign in to continue.",
  "error.forbidden": "You do not have permission for this.",
  "error.csrf_origin": "This request came from another site and was refused.",
  "error.access_required": "Admin access could not be verified.",
  "error.rate_limited": "Too many attempts. Wait a moment and try again.",
  "error.locked": "This is locked. Unlock the configuration or the person first.",
  "error.photo_locked": "The photo is locked by the operator.",
  "error.song_locked": "The song is locked by the operator.",
  "error.consent_required": "Please confirm consent before uploading a photo.",
  "error.quota_exceeded": "The quota for this workspace is used up.",
  "error.too_large": "The file is too large.",
  "error.ext_not_allowed": "This file type is not allowed.",
  "error.media_kind_mismatch": "That file is not the expected type.",
  "error.checksum_mismatch": "The file did not match its checksum. Try the upload again.",
  "error.size_mismatch": "The uploaded size did not match. Try the upload again.",
  "error.empty_body": "The file is empty.",
  "error.length_required": "The upload is missing its length.",
  "error.duration_required": "The song is missing its duration.",
  "error.song_required": "A region needs a song first.",
  "error.region_invalid": "The region is not valid for this song.",
  "error.hotkey_duplicate": "Another slot already uses this hotkey.",
  "error.hotkey_invalid": "This hotkey is not valid.",
  "error.hotkey_reserved": "This hotkey is reserved by the desktop app.",
  "error.person_duplicate": "A person can appear only once in a configuration.",
  "error.person_not_found": "A person in the list no longer exists.",
  "error.export_invalid": "This configuration cannot be exported as it is. Check its slots.",
  "error.owner_protected": "The owner's membership cannot be changed.",
  "error.cannot_remove_self": "You cannot remove yourself.",
  "error.not_invited": "This account has no invitation. Ask the owner for one.",
  "error.invite_invalid": "This invitation is invalid, expired or already used.",
  "error.invite_email_mismatch": "Sign in with the email address the invitation was sent to.",
  "error.email_unverified": "Your Google email address is not verified.",
  "error.oauth_not_configured": "Google sign-in is not configured yet.",
  "error.oauth_state_invalid": "The sign-in expired. Please start again.",
  "error.dev_login_forbidden": "Development sign-in works on localhost only.",

  "admin.nav": "Admin",
  "admin.nav.label": "Admin sections",
  "admin.tabs.workspaces": "Workspaces",
  "admin.col.players": "Players",
  "admin.action.openDetails": "Open details",
  "admin.usage.title": "Usage",
  "admin.usage.players": "Players",
  "admin.workspace.noMembers": "No members.",
  "admin.invites.copyLink": "Copy link",
  "admin.audit.filter.anyWorkspace": "Any workspace",
  "admin.tabs.operators": "Operators",
  "admin.tabs.audit": "Audit log",
  "admin.tabs.errors": "Errors",
  "admin.search": "Search",
  "admin.empty": "Nothing found.",
  "admin.yes": "Yes",
  "admin.no": "No",
  "admin.quota": "{used} of {quota}",
  "admin.filter.status": "Filter by status",
  "admin.status.all": "All statuses",
  "admin.status.active": "Active",
  "admin.status.suspended": "Suspended",
  "admin.status.pending": "Pending",
  "admin.status.deleted": "Deleted",
  "admin.actor.operator": "Operator",
  "admin.actor.admin": "Admin",
  "admin.actor.player": "Player",
  "admin.col.name": "Name",
  "admin.col.owner": "Owner",
  "admin.col.members": "Members",
  "admin.col.persons": "Persons",
  "admin.col.configs": "Configs",
  "admin.col.storage": "Storage",
  "admin.col.status": "Status",
  "admin.col.actions": "Actions",
  "admin.col.email": "Email",
  "admin.col.admin": "Admin",
  "admin.col.identities": "Sign-in methods",
  "admin.col.workspaces": "Workspaces and roles",
  "admin.col.time": "Time",
  "admin.col.actor": "Actor",
  "admin.col.action": "Action",
  "admin.col.workspace": "Workspace",
  "admin.col.target": "Target",
  "admin.col.route": "Route",
  "admin.col.level": "Level",
  "admin.col.code": "Code",
  "admin.col.httpStatus": "HTTP",
  "admin.col.message": "Message",
  "admin.workspaces.title": "Workspaces",
  "admin.workspace.back": "Back to workspaces",
  "admin.workspace.configurations": "Configurations",
  "admin.workspace.noConfigurations": "No configurations.",
  "admin.action.actAs": "Act as",
  "admin.action.edit": "Edit quotas and plan",
  "admin.action.transfer": "Transfer ownership",
  "admin.action.suspend": "Suspend",
  "admin.action.unsuspend": "Unsuspend",
  "admin.action.changeEmail": "Change email",
  "admin.action.unlinkGoogle": "Unlink Google",
  "admin.action.signInLink": "New sign-in link",
  "admin.action.validate": "Validate",
  "admin.invite.open": "Invite sound guy",
  "admin.invite.title": "Invite an operator",
  "admin.invite.email": "Email",
  "admin.invite.workspaceName": "Workspace name (optional)",
  "admin.invite.submit": "Create invite",
  "admin.invite.shownOnce":
    "This link is shown once. Send it to them now. It cannot be shown again.",
  "admin.invite.done": "Done",
  "admin.edit.title": "Edit workspace",
  "admin.edit.name": "Name",
  "admin.edit.plan": "Plan",
  "admin.edit.quotaBytes": "Storage quota (bytes)",
  "admin.edit.quotaPersons": "Person quota",
  "admin.delete.title": "Delete workspace",
  "admin.delete.message": "{name} will be hidden from everyone. You can restore it later.",
  "admin.restore.title": "Restore workspace",
  "admin.restore.message": "{name} will be active again.",
  "admin.transfer.title": "Transfer ownership",
  "admin.transfer.message": "Choose the new owner of {name}. The current owner becomes a member.",
  "admin.transfer.pick": "New owner",
  "admin.transfer.none": "There are no other members to transfer to.",
  "admin.operators.title": "Operators",
  "admin.operators.changeEmail.title": "Change email",
  "admin.operators.newEmail": "New email",
  "admin.operators.signIn.title": "Sign-in link",
  "admin.operators.signIn.explain":
    "This link reconnects {email} to their existing account. Opening it signs them in with Google and attaches that Google account to this operator. No new account is created.",
  "admin.operators.signIn.shownOnce": "This link is shown once. Copy it now.",
  "admin.unlink.title": "Unlink Google",
  "admin.unlink.message":
    "{email} will no longer sign in with this Google account until they reconnect it.",
  "admin.audit.title": "Audit log",
  "admin.audit.filter.workspace": "Workspace ID",
  "admin.audit.filter.actorKind": "Actor kind",
  "admin.audit.filter.anyActor": "Any actor",
  "admin.audit.filter.action": "Action",
  "admin.audit.loadMore": "Load more",
  "admin.errors.title": "Recent errors",
  "admin.errors.filter.workspace": "Workspace ID",
  "admin.validate.noIssues": "No issues found.",
  "admin.validate.count": "{count} issues found",
  "admin.takedown.title": "Take down media by ID",
  "admin.takedown.mediaId": "Media ID",
  "admin.takedown.reason": "Reason",
  "admin.takedown.submit": "Take down",
  "admin.takedown.done": "Media taken down.",
  "admin.takedown.confirm.title": "Take down this media?",
  "admin.takedown.confirm.message":
    "Media {id} will be removed for every viewer. Check the ID before you confirm.",
  "landing.skip": "Skip to content",
  "landing.nav.label": "Page sections",
  "landing.nav.how": "How it works",
  "landing.nav.players": "For players",
  "landing.nav.guys": "For sound guys",
  "landing.action.signIn": "Sign in",
  "landing.action.openApp": "Open app",
  "landing.action.invite": "Ask for an invite",
  "landing.hero.titleTop": "Your goal.",
  "landing.hero.titleBottom": "Your song.",
  "landing.request.title": "Request an invite",
  "landing.request.name": "Name",
  "landing.request.team": "Team",
  "landing.request.email": "Email",
  "landing.request.message": "Message (optional)",
  "landing.request.submit": "Send request",
  "landing.request.required": "This field is required.",
  "landing.request.errorEmail": "Enter an email address like name@club.com.",
  "landing.request.errorValidation": "Check the highlighted fields.",
  "landing.request.errorRateLimited": "Too many requests. Try again later.",
  "landing.request.errorRetry": "Could not send your request. Check your connection and try again.",
  "landing.request.success": "Thanks — we'll email you an invite.",
  "landing.hero.lead":
    "Players pick their goal song and the exact seconds on their phone. The sound guy's board plays it when they score.",
  "landing.wave.label": "Goal song section",
  "landing.wave.valuetext": "{start} to {end}",
  "landing.wave.hint": "Drag the section or use the arrow keys.",
  "landing.wave.demo": "Demo track",
  "landing.zone.players.title": "Defensive zone: the player picks",
  "landing.zone.players.p1": "Each player gets a private link. No account, no app.",
  "landing.zone.players.p2":
    "Upload mp3, m4a or aac, or WAV and FLAC (converted in the browser). Pick 3 to 30 seconds.",
  "landing.zone.guys.title": "Neutral zone: the sound guy lines up",
  "landing.zone.guys.p1":
    "Keep the roster and the configurations in one place, with a hotkey for each song.",
  "landing.zone.guys.p2": "Lock the configuration before the game, and share each player's link.",
  "landing.zone.goal.title": "Offensive zone: the goal",
  "landing.zone.goal.p1": "The desktop soundboard plays each player's section when they score.",
  "landing.zone.goal.p2":
    "Link the desktop with a code. Update pulls in player changes, and your edits upload on their own.",
  "landing.mock.sample": "Sample data",
  "landing.mock.save": "Save",
  "landing.mock.locked": "Locked",
  "landing.mock.config": "Home game",
  "landing.mock.colName": "Name",
  "landing.mock.colSection": "Section",
  "landing.mock.window": "Soundboard",
  "landing.mock.playing": "Playing",
  "landing.closing.title": "Ready for puck drop?",
  "landing.footer.terms": "Free with quotas · Invite-only",
  "download.hero": "Download the desktop app",
  "download.meta": "macOS & Windows · {size} MB · v{version}",
  "download.compact": "Desktop app",
  "download.howToOpen": "How to open it",
  "download.unsigned":
    "Not signed by Apple or Microsoft yet: on first launch use right-click → Open (Mac) or More info → Run anyway (Windows).",
} as const;

export type MessageKey = keyof typeof en;
